import { RingProgress } from '@mantine/core';

const RingProgressDefaults = RingProgress.extend({
  defaultProps: {
    rootColor: 'gray.1',
    size: 100,
    thickness: 15,
  },
  classNames: {},
});

export { RingProgress, RingProgressDefaults };
